'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'balloons';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e2e4';
var svgPathData = ['M294 335.3c30.2-36.2 65.3-89.7 72.6-152.1 11.7-14.2 29.5-23.3 49.4-23.3l0-48c-18.4 0-35.8 4.4-51.1 12.3-2.8-16.2-7.5-31.8-13.9-46.6 19.8-8.8 41.8-13.7 64.9-13.7 88.4 0 160 71.6 160 160 0 112-128 208-128 208l32 80-128 0 32-80s-52.2-39.2-90-96.7z', 'M160 0c88.4 0 160 71.6 160 160 0 112-128 208-128 208l32 80-128 0 32-80S0 272 0 160C0 71.6 71.6 0 160 0zM96 160c0-35.3 28.7-64 64-64l0-48C98.1 48 48 98.1 48 160l48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBalloons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;